// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconListCheck, IconUserPlus, IconFileInfo, IconAlignCenter, IconBoxModel2, IconBoxModel, IconList } from '@tabler/icons';

// constant
const icons = {
    IconListCheck,
    IconUserPlus,
    IconFileInfo,
    IconAlignCenter,
    IconBoxModel2,
    IconBoxModel,
    IconList
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const managerExpenseGroup = {
    id: 'manager-expense-group',
    type: 'group',
    children: [
        {
            id: 'manager-expense',
            title: <FormattedMessage id="expense" />,
            type: 'collapse',
            breadcrumbs: false,
            icon: icons.IconBoxModel,
            children: [
                {
                    id: 'new-expense',
                    title: <FormattedMessage id="new-expense" />,
                    type: 'item',
                    url: '/expense-form',
                    breadcrumbs: false,
                    visible: true
                },
                {
                    id: 'my-expenses',
                    title: <FormattedMessage id="my-expenses" />,
                    type: 'item',
                    url: '/expense-list?type=my_expenses',
                    breadcrumbs: false,
                    visible: true
                },
                {
                    id: 'waiting-my-approve',
                    title: <FormattedMessage id="waiting-my-approve" />,
                    type: 'item',
                    url: '/expense-list?type=waiting_my_approve',
                    icon: icons.IconLoader,
                    breadcrumbs: false,
                    visible: true
                },
                {
                    id: 'my-approved',
                    title: <FormattedMessage id="my-approved" />,
                    type: 'item',
                    url: '/expense-list?type=my-approved',
                    icon: icons.IconSubtask,
                    breadcrumbs: false,
                    visible: true
                },
            ]
        },
    ]
};

export default managerExpenseGroup;
